// @flow
import React from 'react';
import { colors } from '../constants';

type Props = {
  color: string,
  height: number,
  width: number,
  className?: string,
};

const GreenhouseLogoWhiteSquare = ({ height, width, className }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      width={width}
      className={className}
    >
      <g fill="#FEFEFE" fillRule="evenodd">
        <path d="M11.677 13.602a2.415 2.415 0 0 0-2.412 2.412 2.415 2.415 0 0 0 2.412 2.412 2.415 2.415 0 0 0 2.412-2.412 2.415 2.415 0 0 0-2.412-2.412" />
        <path d="M11.677 19.823c-2.1 0-3.809-1.708-3.809-3.809 0-2.1 1.709-3.81 3.81-3.81 2.1 0 3.809 1.71 3.809 3.81s-1.71 3.81-3.81 3.81zm-.593-14.52A3.22 3.22 0 0 1 14.3 8.52a3.22 3.22 0 0 1-3.216 3.216 3.22 3.22 0 0 1-3.216-3.216 3.22 3.22 0 0 1 3.216-3.216zm2.471-1.517a.974.974 0 0 1 0 1.945.974.974 0 0 1 0-1.945zM0 23.496h23.495V0H0v23.495z" />
        <path d="M11.084 10.323c.995 0 1.805-.809 1.805-1.804s-.81-1.804-1.805-1.804c-.995 0-1.805.81-1.805 1.804 0 .995.81 1.804 1.805 1.804" />
      </g>
    </svg>
  );
};

GreenhouseLogoWhiteSquare.defaultProps = {
  color: colors.lightestGrey,
  height: 24,
  width: 24,
};

export default GreenhouseLogoWhiteSquare;
